<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-slot-machine-outline"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingMachine"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="machine.name"
                        >
                          <v-text-field
                            v-model="machine.name"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.machine.name')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="machine.serialNumber"
                        >
                          <v-text-field
                            v-model="machine.serialNumber"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.machine.serialNumber')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="machine.model"
                        >
                          <v-text-field
                            v-model="machine.model"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.machine.model')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="machine.brandName"
                        >
                          <v-text-field
                            v-model="machine.brandName"
                            outlined
                            name="machine.brandName"
                            :label="$t('fields.machine.brandName')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="machine.machineStatus"
                        >
                          <v-select
                            v-model="machine.machineStatusId"
                            :items="machineStatuses"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.machine.machineStatus')"
                            :error-messages="errors"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="machine.isRented"
                        >
                          <v-switch
                            v-model="machine.isRented"
                            class="mx-2"
                            :label="$t('fields.machine.isRented')"
                            :error-messages="errors"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="between:0,100|required_if:machine.isRented,true"
                          name="machine.ownerPercentage"
                        >
                          <v-text-field
                            v-model.number="machine.ownerPercentage"
                            outlined
                            name="machine.ownerPercentage"
                            :label="$t('fields.machine.ownerPercentage')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="numeric|required"
                          name="machine.denominationExchangeRate"
                        >
                          <v-text-field
                            v-model.number="machine.denominationExchangeRate"
                            outlined
                            name="machine.denominationExchangeRate"
                            :label="$t('fields.machine.denominationExchangeRate')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="numeric|required"
                          name="machine.creditExchangeRate"
                        >
                          <v-text-field
                            v-model.number="machine.creditExchangeRate"
                            outlined
                            name="machine.creditExchangeRate"
                            :label="$t('fields.machine.creditExchangeRate')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="goToList"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                    :loading="loadingSave"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const machinesRespository = repositoryFactory.get('machines')
  const parameterRespository = repositoryFactory.get('parameters')

  export default {
    inject: ['theme'],
    name: 'MachineCrud',
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      machine: {
        isRented: false,
      },
      machineStatuses: [],
      showErrorMessage: false,
      errorMessage: '',
      loadingMachine: false,
      formAction: null,
      loadingSave: false,
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-machine') : this.$t('modify-machine')
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingMachine = true
        var id = this.$route.params.id
        machinesRespository.getById(id).then(response => {
          self.loadingMachine = false
          self.machine = Object.assign({}, response.data.data)
        }).catch(err => {
          self.loadingMachine = false
          alert(err)
        })
      }
      this.getMachineStatuses()
    },
    methods: {
      submitForm (scope) {
        var self = this
        var data = {
          data: this.machine,
        }
        self.loadingSave = true
        if (self.formAction !== 'add') {
          machinesRespository.updateMachine(data, this.machine.id).then(response => {
            if (response.data.isValid) {
              self.goToList()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = true
          })
        } else {
          machinesRespository.addMachine(data).then(response => {
            if (response.data.isValid) {
              self.goToList()
              self.formAction = 'modify'
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
        }
      },
      getMachineStatuses () {
        var self = this
        parameterRespository.getMachineStatuses().then(response => {
          self.machineStatuses = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      goToList () {
        this.$router.push({ name: 'machines' })
      },
    },
  }
</script>
